import { EMAIL_MATCHER, URL_MATCHER } from '#pplx/frontend/composer-sdk/internal/link/matchers.js';
export function resolveLinkMatchers(matchers) {
    return matchers.map((matcher) => {
        if (matcher === 'url') {
            return URL_MATCHER;
        }
        if (matcher === 'email') {
            return EMAIL_MATCHER;
        }
        return (text) => {
            const result = matcher.match(text);
            if (result === null) {
                return null;
            }
            return {
                ...result,
                text: text.slice(result.index, result.index + result.length),
            };
        };
    });
}
//# sourceMappingURL=resolveLinkMatchers.js.map